const Footer = () => {
    return (
        <footer className="text-center font-[roboto] mt-10">
            <p className='text-gray-400 py-5 text-sm font-bold'>Created by JoniHaarala - devChallenges.io</p>
        </footer>
    );
}

export default Footer;